


























































































import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import { IProductCard, ICategory } from "@/@types/menu/menu/menu";
import { ICoast } from "@/@types/_shared/coast";
import StandartTable from "@/components/tables/standart-table.vue";

@Component({ components: { StandartTable } })
export default class RecuclerList extends Vue {
  @Inject({ from: "dishFolder", default: "menu/dishs" })
  readonly folder!: string;

  @Prop({ type: Array, default: () => [] }) list!: Array<IProductCard>;
  @Prop({ type: Array, default: () => [] }) categoryList!: Array<ICategory>;
  @Prop({ type: String, default: "" }) activeBar!: string;

  getCategory(id: string | undefined): string {
    if (!id) return "-";
    const cat = this.categoryList.find((el) => el._id == id);
    return cat ? this.$getLocale(cat.name) : "-";
  }

  getCoasts(product: IProductCard): Array<ICoast> {
    if (!product.params || !product.params.length) return [];
    const out: Array<ICoast> = [];
    for (const p of product.params) {
      if (!p || !p.coast) continue;
      for (const c of p.coast) {
        if (c && c.value && c.currency) out.push(c);
      }
    }
    return out;
  }
}
